import { render, staticRenderFns } from "./TheSettingsStartsCategories.vue?vue&type=template&id=896a3240&"
import script from "./TheSettingsStartsCategories.vue?vue&type=script&lang=js&"
export * from "./TheSettingsStartsCategories.vue?vue&type=script&lang=js&"
import style0 from "./TheSettingsStartsCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports